import { render, staticRenderFns } from "./RightsResult.vue?vue&type=template&id=033f0a7f"
import script from "./RightsResult.vue?vue&type=script&lang=js"
export * from "./RightsResult.vue?vue&type=script&lang=js"
import style0 from "./RightsResult.vue?vue&type=style&index=0&id=033f0a7f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports